import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import CheeseProduct from 'models/CheeseProduct'
import CheesePackage from './CheesePackage'

const productOptions = {
  packagingInfo: <CheesePackage />,
  productTitle: 'Cheese',
  model: CheeseProduct,
  validCategories: ['02'],
  validSubCategories: ['001'],
}

const Cheese = () => <ProductForm product={productOptions} />

export default Cheese
